import type { BackendTypes } from '@tf/api';
import { createContext } from 'react';

export interface FormSegmentMeta {
	identity: BackendTypes.SegmentIdentity;
	accessMode?: BackendTypes.AccessModeKind;
}

export const SegmentContext = createContext<FormSegmentMeta | null>(null);
